import { Compass } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

const ImHereTo = () => {
  return (
    <div className="m-3">
    <div className='container p-4 md:p-3 flex flex-col lg:flex-row items-center justify-between gap-6 m-auto bg-[#ffedfd] rounded-xl relative overflow-hidden'>
        <div className="absolute -left-0.5 h-6 w-2 bg-[#e83f3b] rounded-lg"/>
        <div className="flex items-center gap-2 ">
            <Compass className='text-[#6540b2]'/>
            <h6 className='text-[#6540b2] text-lg'>I'm here to</h6>
        </div>
        <div className="flex flex-wrap items-center gap-3">
            <Link to='/' className='bg-[#f6f7f9] px-4 py-1.5 mb-0 rounded-xl text-[#6540b2] hover:text-[#e83f3b]'>Send Crypto Money</Link> 
            <Link to='/' className='bg-[#f6f7f9] px-4 py-1.5 mb-0 rounded-xl text-[#6540b2] hover:text-[#e83f3b]'>Top Up Account</Link> 
            <Link to='/' className='bg-[#f6f7f9] px-4 py-1.5 mb-0 rounded-xl text-[#6540b2] hover:text-[#e83f3b]'>Auto Staking</Link> 
            <Link to='/' className='bg-[#f6f7f9] px-4 py-1.5 mb-0 rounded-xl text-[#6540b2] hover:text-[#e83f3b]'>Bill & Payment</Link> 
            <Link to='/' className='bg-[#f6f7f9] px-4 py-1.5 mb-0 rounded-xl text-[#6540b2] hover:text-[#e83f3b]'>5% Auto ROI</Link>
            <Link to='/' className='bg-[#f6f7f9] px-4 py-1.5 mb-0 rounded-xl text-[#6540b2] hover:text-[#e83f3b]'>Crypto Cards</Link>
        </div>
        <div className="">
            <p className='text-[#6540b2]'>//Find the best product for your daily life.</p>
        </div>
    </div>
    </div>
  )
}

export default ImHereTo